module.exports = __webpack_public_path__ + "static/img/sky-edit.0d4365f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Parts/Key3D/cdp/sky-edit.jpg
// module id = 15
// module chunks = 0